import { connect } from 'react-redux';
import React from 'react';
import { Form } from 'antd';
import { KBButton, KBUserInput } from 'components';
import { SAFE_SETTING } from 'app/constants/hint';
import * as selectors from 'app/selectors';
import * as roleUtils from 'app/reducers/role';

const usersToValue = users =>
  users && users.length ? users.map(user => user.id).join(',') : '';
const getChangeValue = value => (value && value.target ? value.target.value : value);

function FormField({ children, onChange, value }) {
  return children({
    value,
    onChange: nextValue => onChange(getChangeValue(nextValue))
  });
}

const getInitialValues = props => ({
  range: props.settingValue || props.defaultRange || 'admin',
  users: usersToValue(props.selectUsers)
});

function SpaceRoleRangeForm(props) {
  const { role, updateSpaceRole, users, selectUsers } = props;
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = React.useState(false);
  const initialValues = React.useMemo(() => getInitialValues(props), [
    props.settingValue,
    props.defaultRange,
    props.selectUsers
  ]);
  const initialValuesKey = JSON.stringify(initialValues);

  React.useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [form, initialValuesKey]);

  const renderField = (name, render) => (
    <Form.Item name={name} noStyle>
      <FormField>{render}</FormField>
    </Form.Item>
  );

  const handleFinish = values => {
    const result = updateSpaceRole({
      role,
      range: values.range,
      user_ids:
        values.range === 'admin' ? [] : values.users ? values.users.split(',') : []
    });

    setSubmitting(true);
    if (result && result.then) {
      return result.then(
        value => {
          setSubmitting(false);
          return value;
        },
        error => {
          setSubmitting(false);
          throw error;
        }
      );
    }
    setSubmitting(false);
    return result;
  };

  return (
    <Form form={form} initialValues={initialValues} onFinish={handleFinish}>
      <div className="kb-form-container" style={{ padding: 0 }}>
        {renderField('range', rangeField => (
          <div>
            <div className="kb-row">
              <label>
                <input
                  type="radio"
                  onChange={rangeField.onChange}
                  value="admin"
                  checked={rangeField.value === 'admin'}
                />{' '}
                只有管理员可以阅览和更改
              </label>
            </div>
            <div className="kb-row">
              <label>
                <input
                  type="radio"
                  onChange={rangeField.onChange}
                  value="all"
                  checked={rangeField.value === 'all'}
                />{' '}
                全部员工可以阅览和更改
              </label>
            </div>
            <div className="kb-row">
              <label>
                <input
                  type="radio"
                  onChange={rangeField.onChange}
                  value="group"
                  checked={rangeField.value === 'group'}
                />{' '}
                只有指定员工可以阅览和更改
              </label>
            </div>
            {rangeField.value === 'group'
              ? renderField('users', field => (
                  <KBUserInput
                    hint={SAFE_SETTING.staff}
                    selectedUsers={selectUsers}
                    users={users}
                    multi={true}
                    field={field}

                  />
                ))
              : null}
          </div>
        ))}

        <div className="kb-row m-top">
          <KBButton className="certain-btn" type="button" submitting={submitting} onClick={() => form.submit()}>
            保存
          </KBButton>
        </div>
      </div>
    </Form>
  );
}

function mapStateToProps(state, props) {
  const { roles_settings = {}, roles = [] } = props.spaceRole || {};
  const userIds = roleUtils.getRoleUserByKey(roles, props.role);
  return {
    users: selectors.getSpaceUsers(state),
    selectUsers: selectors.getUsersByUserIds(state, userIds) || [],
    settingValue: roles_settings[props.settingKey]
  };
}

export default connect(mapStateToProps)(SpaceRoleRangeForm);
